import ContentCard from '@components/content/ContentCard'
import UIText from '@components/ui/UIText'
import { Box } from '@mui/joy'
import { ArticleListResponseVo } from '@schemas/non-auth'
import { theme } from '@ui/style'
import { pxToRem } from '@ui/style/muiTheme'
import { getRelativeTime } from '@utils/date'
import { cardProps, rankStyle } from '.'
import { AreaDiv } from '@services/api/Statistics/types'
import { getArticleLink } from '@utils/getLink'
import { imgDefaultH } from 'src/shared/variables'

type ArticleItmeProps = {
	article: ArticleListResponseVo
	hasRanking?: boolean
	index: number
	areaDiv?: AreaDiv
	areaIdx?: number
}
const ArticleItem = ({ article, index, hasRanking, areaDiv, areaIdx }: ArticleItmeProps) => (
	<Box
		display={{ sm: 'none', md: 'flex', lg: 'none' }}
		pt={pxToRem(12)}
		pb={pxToRem(11)}
		width="100%"
		sx={{
			borderBottom: `1px solid ${theme.color.colGray3}`,
			'&>*:not(:first-child)': {
				marginLeft: pxToRem(12),
			},
			'&>div': {
				width: '100%',
			},
		}}
		className="articleListItem"
	>
		{hasRanking && <UIText {...rankStyle}>{index + 1}</UIText>}
		<ContentCard
			content={{
				title: article.articleTitle,
				href: getArticleLink(article, areaDiv, areaIdx),
				src:
					(article.vodInfo
						? article.vodInfo.vodThumbnailImgUrl
						: article.articleThumbnailImgUrl) ?? imgDefaultH,
				alt: `${article.articleTitle} 썸네일 이미지`,
				additionalText: getRelativeTime(article.publicationDate) ?? '',
				duration: article?.vodInfo?.playTime ?? '',
				showVideoViewIcon: article.isVideoView,
			}}
			layoutConfig={cardProps.layoutConfig}
			thumbnailConfig={{
				...cardProps.thumbnailConfig,
				isContain: article.articleThumbnailImageViewType !== 'WIDTH',
			}}
			infoConfig={cardProps.infoConfig}
		/>
	</Box>
)
export default ArticleItem
